import { Fab, Grid, withStyles } from '@material-ui/core';
import React, { useState, useRef, useCallback } from 'react';
import { RiUploadCloud2Line } from "react-icons/ri";
import Button from '@material-ui/core/Button';
import Dropzone from 'react-dropzone';
import { FaFilePdf, FaImage } from "react-icons/fa";
import { RiDeleteBin6Line } from "react-icons/ri";
import { IoIosCheckmarkCircle } from "react-icons/io";
import styles from './Styles';
import CommonFooter from '../CommonFooter';
import Header from '../Header';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import customStyle from '../programInfo/CSS/stylesheet_UHS.js';
import ForumIcon from '@material-ui/icons/Forum';
import jsPDF from 'jspdf';
import axios from 'axios';
import CommonLoader from '../../CommonLoader';
import { isMobile } from 'react-device-detect'
import MobileFooter from '../../MobileScreen/MobileFooter';
import MobCopyright from '../../MobileScreen/MobCopyright';

const CrudButton = withStyles(customStyle.crudBtn)(Fab)

const ReimbursementUpload = ({
    backClick,
    ...props
}) => {
    const fileInputRef = useRef(null);
    const isFileDialogOpen = useRef(false);

    const [uploadFileNames, setUploadFileNames] = useState("");
    const [fileSizes, setFileSizes] = useState("");
    const [fileTypes, setFileTypes] = useState("");
    const [limitError, setLimitError] = useState("");
    const [loader, setLoader] = useState(false);
    const [files, setFiles] = useState([]);

    const handleDrop = (e) => {
        let files = e;

        if (files.length > 0) {
            const validTypes = ["image/jpeg", "image/png", "application/pdf"];
            const maxFileSize = 50 * 1024 * 1024;

            let totalImageSize = 0;
            const validFiles = files.filter(file => {
                if (file.type.startsWith("image/")) {
                    totalImageSize += file.size;
                }
                return (
                    (file.type.startsWith("image/") && totalImageSize <= maxFileSize) ||
                    (file.type === "application/pdf" && file.size <= maxFileSize)
                );
            });

            if (totalImageSize <= maxFileSize && validFiles.length > 0) {
                setUploadFileNames(validFiles.map(file => file.name));
                setFileSizes(validFiles.map(file => formatFileSize(file.size)));
                setFileTypes(validFiles.map(file => file.type));
                setFiles(validFiles);
                setLimitError("");
            } else {
                setUploadFileNames([]);
                setFileSizes([]);
                setFileTypes([]);
                setFiles([]);
                setLimitError("Please upload JPEG, PNG, or PDF files within 50MB size limit.");
            }
        }
    };

    const handleChangeFile = (e) => {
        if (e.target.files.length > 0) {
            console.log("File selected:", e.target.files[0]);
        } else {
            console.log("File selection canceled");
        }

        const files = Array.from(e.target.files);
        const validTypes = ["image/jpeg", "image/png", "application/pdf"];
        const maxFileSize = 50 * 1024 * 1024;

        let totalImageSize = 0;
        const validFiles = files.filter(file => {
            if (file.type.startsWith("image/")) {
                totalImageSize += file.size;
            }
            return (
                (file.type.startsWith("image/") && totalImageSize <= maxFileSize) ||
                (file.type === "application/pdf" && file.size <= maxFileSize)
            );
        });

        if (totalImageSize <= maxFileSize && validFiles.length > 0) {
            setUploadFileNames(validFiles.map(file => file.name));
            setFileSizes(validFiles.map(file => formatFileSize(file.size)));
            setFileTypes(validFiles.map(file => file.type));
            setFiles(validFiles);
            setLimitError("");
        } else {
            setUploadFileNames([]);
            setFileSizes([]);
            setFileTypes([]);
            setFiles([]);
            setLimitError("Please upload JPEG, PNG, or PDF files within the 50MB size limit.");
        }

        fileInputRef.current.value = null;
        setTimeout(() => {
            isFileDialogOpen.current = false;
        }, 500);
    };

    const handleButtonClick = useCallback((event) => {
        event.preventDefault();
        if (isFileDialogOpen.current) {
            return;
        }
        isFileDialogOpen.current = true;
        fileInputRef.current.click();
        setTimeout(() => {
            isFileDialogOpen.current = false;
        }, 500);
    }, []);

    const formatFileSize = (size) => {
        if (size < 1024) return `${size} B`;
        if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`;
        if (size < 1024 * 1024 * 1024) return `${(size / (1024 * 1024)).toFixed(2)} MB`;
        return `${(size / (1024 * 1024 * 1024)).toFixed(2)} GB`;
    };

    const handleDeleteFile = (index) => {
        setUploadFileNames(prev => prev.filter((_, i) => i !== index));
        setFileSizes(prev => prev.filter((_, i) => i !== index));
        setFiles(prev => prev.filter((_, i) => i !== index));
    };

    const submitReimbursement = async () => {
        const memberId = localStorage.getItem('Member_EMPID').replace(/\D/g, "");
        setLoader(true);
        if (memberId) {
            const formatTimestamp = () => {
                const now = new Date();
                return now.toISOString().slice(0, 19).replace("T", " ");
            };
            const formattedTimestamp = formatTimestamp();

            const pdfFiles = files.filter(file => file.type === "application/pdf");
            const imageFiles = files.filter(file => file.type.startsWith("image/"));

            const renameFile = (file, newName) => {
                return new File([file], newName, { type: file.type });
            };

            const uploadFile = async (file) => {
                let formData = new FormData();
                formData.append("file", file);
                formData.append(
                    "requestData",
                    JSON.stringify({
                        memberId,
                        claimId: null,
                        status: "Being Processed",
                        uploadedDate: formattedTimestamp,
                    })
                );

                try {
                    await axios.post(`${process.env.REACT_APP_NEW_BASE_URL}/memberportal/claims`, formData)
                        .then(res => {
                            if (res.data.code == 200) {
                            } else {
                                setLimitError("Could not submit claim, please try again.");
                            }
                        })
                } catch (error) {
                    console.error("Upload failed:", error);
                }
            };

            for (let pdf of pdfFiles) {
                const newFileName = `${pdf.name.split(".")[0]}_${memberId}_${formattedTimestamp}.pdf`;
                const renamedPdf = renameFile(pdf, newFileName);
                await uploadFile(renamedPdf);
            }

            if (imageFiles.length > 0) {
                const pdf = new jsPDF();

                for (let i = 0; i < imageFiles.length; i++) {
                    const imgData = await readFileAsDataURL(imageFiles[i]);
                    const img = new Image();
                    img.src = imgData;

                    await new Promise(resolve => {
                        img.onload = () => {
                            const width = pdf.internal.pageSize.getWidth();
                            const height = (img.height / img.width) * width;
                            if (i > 0) pdf.addPage();
                            pdf.addImage(img, "JPEG", 0, 0, width, height);
                            resolve();
                        };
                    });
                }

                const pdfBlob = pdf.output("blob");
                const mergedPdfFile = new File([pdfBlob], `claimsPDF_${memberId}_${formattedTimestamp}.pdf`, { type: "application/pdf" });

                await uploadFile(mergedPdfFile);
            }
        } else {
            setLimitError("Could not submit claim as Member ID is not generated yet.");
        }
        setLoader(false);
        backClick();
    };

    const readFileAsDataURL = (file) => {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.readAsDataURL(file);
        });
    };

    return (
        <div className="progInfoMainWrapper" style={{ marginBottom: 10 }}>
            {loader ? <CommonLoader /> : null}
            {
                isMobile ?
                    <div className="mobileHeaderWrapper" style={{ marginTop: -19 }}>
                        <div onClick={() => backClick()}>
                            <ArrowBackIcon style={{ width: '24px', height: '24px', color: '#2e3192' }} />
                        </div>
                        <div className="mobileHeaderTitle">Reimbursement Request</div>
                    </div>
                    :
                    <Header name={'MyNeeds'} />
            }
            <div className="container progInfoContainer" style={{ zIndex: '0' }}>
                <sapn className="Back_page" onClick={() => backClick()}>
                    <ArrowBackIcon style={styles.backArrow} onClick={() => backClick()} />
                    BACK
                </sapn>
                <div style={styles.progInfoSection}>
                    <Grid container direction="row" style={{ marginTop: isMobile && 40 }}>
                        <Grid item sm={8} md={8} style={styles.uploadContainer}>
                            {
                                !isMobile &&
                                <h2>REIMBURSEMENT REQUEST</h2>
                            }
                            <Dropzone onDrop={(e) => handleDrop(e)}>
                                {({ getRootProps, getInputProps }) => (
                                    <div {...getRootProps({ className: "dropzone" })}>
                                        <input {...getInputProps()} />
                                        <Grid className="uploadWrapContainer" style={styles.dropZone}>
                                            <div className="drop-it-hot" id="drop-area">
                                                <form className="choose-files">
                                                    <Grid className="button-wrapper" style={styles.dropArea}>
                                                        <RiUploadCloud2Line size={40} color='#fec465' style={styles.uploadIcon} />
                                                        <div style={styles.uploadTitle}>
                                                            <label className="label" for="fileElem" style={styles.smallFont}>Choose multiple files or drag & drop them here</label>
                                                            <label style={styles.greyColor} className="label" for="fileElem">JPEG, PNG, and PDF formats, up to 50MB</label>
                                                        </div>
                                                        <Grid style={styles.dropInput}>
                                                            <input
                                                                type="file"
                                                                id="fileElem"
                                                                accept=".png,.jpeg,.pdf"
                                                                onChange={handleChangeFile}
                                                                onClick={(e) => {
                                                                    console.log("File input clicked");
                                                                    e.stopPropagation(); // Prevent bubbling
                                                                    e.preventDefault();
                                                                }}
                                                                style={{ display: "none" }}
                                                                ref={fileInputRef}
                                                            />
                                                            <Button variant='outlined' onClick={handleButtonClick} style={styles.browseButton}>
                                                                BROWSE FILE
                                                            </Button>
                                                        </Grid>
                                                        <text style={styles.limitError}>{limitError}</text>
                                                    </Grid>
                                                </form>
                                            </div>
                                        </Grid>
                                    </div>
                                )}
                            </Dropzone>
                        </Grid>
                        <Grid item sm={4} md={4} style={styles.filesContainer}>
                            {uploadFileNames.length > 0 ? (
                                uploadFileNames.map((name, index) => (
                                    <div style={styles.fileContainer} key={index}>
                                        <div style={styles.fileIcon}>
                                            {
                                                fileTypes[index]?.includes("image") ?
                                                    <FaImage size={30} color='#1d8ed8' />
                                                    :
                                                    <FaFilePdf size={30} color='#d81d40' />
                                            }
                                        </div>
                                        <div style={styles.fileDetails}>
                                            <div style={styles.fileName}>
                                                {name}
                                            </div>
                                            <div style={styles.fileSize}>
                                                {fileSizes[index]} of {fileSizes[index]}
                                                <ul style={styles.fileStatus}>
                                                    <li></li>
                                                    <IoIosCheckmarkCircle size={20} color='#3dbe8e' style={{ marginLeft: 10 }} />
                                                    <text style={{ color: "#000", marginLeft: 5 }}>  Completed</text>
                                                </ul>
                                            </div>
                                        </div>
                                        <div onClick={() => handleDeleteFile(index)} style={styles.deleteIcon}>
                                            <RiDeleteBin6Line size={20} />
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div>No files selected</div>
                            )}
                        </Grid>
                    </Grid>
                </div>
                <div className="progInfoFooter">
                    <div className="row">
                        <div className="col-md-8 col-sm-12">
                            <div>
                                <Button variant='filled' style={{ margin: 10, height: 40, width: isMobile ? 120 : 150, backgroundColor: '#60bec9', color: "#fff", borderRadius: 25 }} onClick={() => backClick()}>
                                    CANCEL
                                </Button>
                                <Button variant='filled' style={{ margin: 10, height: 40, width: isMobile ? 120 : 150, backgroundColor: !files[0] ? '#a9acac' : '#60bec9', color: "#fff", borderRadius: 25 }} onClick={() => submitReimbursement()} disabled={!files[0]}>
                                    DONE
                                </Button>
                            </div>
                        </div>
                        <div className="col-md-4 dpFlex">
                            <div className="footerText" style={{ display: 'flex', flexDirection: 'row', whiteSpace: 'nowrap', textWrap: "auto" }}>
                                <div>
                                    <p>Need help?</p>
                                    <p>Chat with a Universal Health Fellowship Representative</p>
                                    <p>{`or call ${localStorage.getItem('CONTACT_NUMBER')}`}
                                    </p>
                                </div>
                                <div style={{ marginLeft: 12 }}>
                                    <CrudButton
                                        className={'purechat-button-expand'}
                                        color="primary"
                                        onClick={() => window.pureChat()}
                                        aria-label="add"
                                        style={customStyle.CommonChatBtn}
                                    >
                                        <ForumIcon />
                                    </CrudButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                isMobile ?
                    <div style={{ paddingTop: "23vh", marginBottom: 30 }}>
                        <MobCopyright />
                        <div class="fixed-bottom">
                            <MobileFooter name="My Needs" />
                        </div>
                    </div>
                    :
                    <div style={{ paddingTop: "23vh" }}>
                        <CommonFooter />
                    </div>
            }
        </div>
    )
}

export default ReimbursementUpload
